























































































import {
  defineComponent,
  nextTick,
  ref,
  computed,
} from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import { CommodityPo } from '@/po/commodity';
import { formatContractName, getContractIframeUrl } from '@/views_v2/pre-apply-choose/utils';
import { Tabs, TabItem as Tab, Checkbox } from '@hb/coffee';
import CommonTitleTip from '../common-title-tip/index.vue';

export default defineComponent({
  components: {
    CommonTitleTip,
    Tabs,
    Tab,
    Checkbox,
  },
  props: {
    channelList: {
      type: Array as PropType<CommodityPo.Info[]>,
      default: () => [],
      required: true,
    },
    isParallel: {
      type: Boolean,
      required: true,
    },
    showMemberCard: {
      type: Boolean,
      required: true,
    },
    /** 是否需要补充资料 */
    needSupplement: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['changeSelect'],
  setup(props, context) {
    /** 当前选中渠道信息 */
    const activityChannel = ref<CommodityPo.Info>(props.channelList[0]);
    /** 当前选中渠道下标 */
    const activityChannelIndex = ref(0);
    /** 当前选中协议下标 */
    const activityContractIndex = ref(0);
    /** 底部提示文案 */
    const footerTip = computed(() => (
      props.isParallel
        ? '以上资方为您提供额度，为更好地提供服务，将同时为您发起申请，必要时您可主动选择资方。'
        : '以上资方为您提供额度，为更好地提供服务，若其中任何一家审批通过，则不再向其余机构提交申请。'
    ));

    /** 当前选中协议iframe地址 */
    const currentIframeUrl = computed(() => {
      const contractItem = activityChannel.value.contractList?.[activityContractIndex.value];
      const url = contractItem?.url || '';
      return getContractIframeUrl(activityChannel.value.commodityId, url);
    });

    /**
     * 当前选中协议item滚动到可视区
     * @param index 协议下标
     */
    const activeContractIntoView = (index: number) => {
      nextTick(() => {
        const activeContractElement = document.querySelector(
          `[data-contract-index="${index}"]`,
        );
        if (activeContractElement) {
          activeContractElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    };
    /** 切换渠道 */
    const onChangeActivityChannel = (index: number) => {
      activityChannelIndex.value = index;
      activityChannel.value = props.channelList[index];
      activityContractIndex.value = 0;
      activeContractIntoView(0);
    };

    /** 切换合同 */
    const onChangeContract = (index: number) => {
      activityContractIndex.value = index;
      activeContractIntoView(index);
    };

    const toggleSelect = () => {
      const { isSelected, commodityId } = activityChannel.value;
      activityChannel.value = {
        ...activityChannel.value,
        isSelected: !isSelected,
      };
      context.emit('changeSelect', commodityId);
    };

    return {
      activityChannel,
      activityChannelIndex,
      activityContractIndex,
      currentIframeUrl,
      footerTip,
      onChangeActivityChannel,
      onChangeContract,
      formatContractName,
      toggleSelect,
    };
  },
});
